import React from "react";

const ProjectData = () => {
  return <div>ProjectData</div>;
};

export default ProjectData;
